import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import CKEditor from 'ckeditor4-vue';
import Notifications from 'vue-notification';
import VuejsDialog from 'vuejs-dialog';
import { ApolloClient } from 'apollo-client';
import SimpleVueValidation from 'simple-vue-validator';
import Multiselect from 'vue-multiselect';
import VueApollo from 'vue-apollo';
import VueJwtDecode from 'vue-jwt-decode';
import { getAccessToken, setAccessToken, relogin } from './accessToken';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink, createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink, Observable } from 'apollo-link';
import { TokenRefreshLink } from 'apollo-link-token-refresh';
import jwtDecode from 'jwt-decode';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import vuetify from './plugins/vuetify';
import LoadScript from 'vue-plugin-load-script';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import JsonExcel from 'vue-json-excel';
import axios from 'axios';
import { generarCodigoPersona, gettokenheaderrest } from '@/components/Utils.js';
import {conectarws} from './ws.js'

const cache = new InMemoryCache({});

SimpleVueValidation.extendTemplates({
  error: 'Error.',
  required: 'Campo obligatorio',
  mustBeFloat: 'Debe ser un numero.',
  mustBeInteger: 'Must be integer.',
  mustBeNumber: 'Must be number.',
  mustLessThan: 'Debe ser un valor menor a {0}.',
  mustLessThanOrEqualTo: 'Must less than or equal to {0}.',
  mustGreaterThan: 'Must greater than {0}.',
  mustGreaterThanOrEqualTo: 'Must greater than or equal to {0}.',
  mustBetween: 'Must between {0} and {1}.',
  sizeMustBe: 'Size must be {0}.',
  lengthMustBe: 'Length must be {0}.',
  lengthAtLeast: 'Must have {0} characters at least.',
  lengthAtMost: 'Must have {0} characters at most.',
  lengthMustBetween: 'Length must between {0} and {1}.',
  valueMustIn: 'Must be {0}.',
  valueMustNotIn: 'Must not be {0}.',
  valueNotMatch: 'Not matched.',
  regexInvalid: 'Formato no valido.',
  digitInvalid: 'Must be digit.',
  emailInvalid: 'Correo invalido.',
  urlInvalid: 'Invalid url.',
  float: 'Must be number.',
  integer: 'Must be integer.',
  number: 'Debe ser un numero.',
  lessThan: 'Debe ser un valor menor a {0}.',
  lessThanOrEqualTo: 'Must less than or equal to {0}.',
  greaterThan: 'Must greater than {0}.',
  greaterThanOrEqualTo: 'Must greater than or equal to {0}.',
  between: 'Must between {0} and {1}.',
  size: 'Size must be {0}.',
  length: 'Length must be {0}.',
  minLength: 'Debe ser de al menos {0} caracteres.',
  maxLength: 'Must have {0} characters at most.',
  lengthBetween: 'Length must between {0} and {1}.',
  in: 'Must be {0}.',
  notIn: 'Must not be {0}.',
  match: 'Not matched.',
  regex: 'Formato no valido.',
  digit: 'Debe ser un digito.',
  email: 'Correo invalido.',
  url: 'Invalid url.',
  optionCombiner: function(options) {
    if (options.length > 2) {
      options = [options.slice(0, options.length - 1).join(', '), options[options.length - 1]];
    }
    return options.join(' or ');
  },
});

Vue.use(LoadScript);
Vue.use(CKEditor);
Vue.use(Notifications);
Vue.use(VueApollo);
Vue.use(SimpleVueValidation);
Vue.use(VueJwtDecode);
Vue.use(VuejsDialog, { okText: 'Continuar', cancelText: 'Cancelar', html: true, loader: false, reverse: true });
Vue.use(VuejsDialogMixin);
Vue.component('downloadExcel', JsonExcel);
Vue.component('multiselect', Multiselect);
VueJwtDecode.decode('<your jwt>');
Vue.prototype.$generarCodigoPersona = generarCodigoPersona;

// vue select
import vSelect from 'vue-select'
Vue.component('vue-select', vSelect)
// end vue select

let ops = {
  defaultCountry: 'bo',
  mode: 'international',
  inputOptions: {
    placeholder: 'Nro celular...',
  },
};
Vue.use(VueTelInput, ops);

const gra = process.env.VUE_APP_GRAPHQL;
const auth = process.env.VUE_APP_AUTH;
const refres = process.env.VUE_APP_REFRESH;
const authrest = process.env.VUE_APP_AUTH_POST;
const proyectos = process.env.VUE_APP_PROYECTOS_API;

const requestLink = new ApolloLink(
  (operation, forward) =>
    new Observable((observer) => {
      let handle;
      Promise.resolve(operation)
        .then((operation) => {
          const accessToken = getAccessToken();
          axios.defaults.headers.common = gettokenheaderrest();
          // window.console.log('Main axios ', JSON.stringify(axios.defaults.headers.common), accessToken);
          operation.setContext({
            headers: {
              authorization: `bearer ${accessToken}`,
            },
          });
        })
        .then(() => {
          handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer),
          });
        })
        .catch(observer.error.bind(observer));

      return () => {
        if (handle) handle.unsubscribe();
      };
    }),
);

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    new TokenRefreshLink({
      accessTokenField: 'accessToken',
      isTokenValidOrUndefined: () => {
        const token = getAccessToken();
        //relogin( auth );
        if (!token) {
          return true;
        }

        try {
          const { exp } = jwtDecode(token);
          var noww = Date.now() + 1000 * 60 * 1;
          var expp = exp * 1000;
          var isExpp = noww >= expp;

          if (isExpp) {
            return false;
          } else {
            return true;
          }
        } catch {
          return false;
        }
      },
      fetchAccessToken: () => {
        //const datauser = window.localStorage.getItem( "USERDATALOGIN" );
        const ocultito = window.localStorage.getItem('USERDATALOGIN');
        let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
        let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
        //window.console.log( 'DECRYPTO:',plaintext );
        const datauser = plaintext;

        var u = JSON.parse(datauser);
        if (!u) {
          u = {};
          window.location.href = '/' + process.env.VUE_APP_BASE_URL;
          return;
        }
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        var raw = JSON.stringify({ username: u.user, password: u.clave });
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        return fetch(authrest, requestOptions);
      },
      handleFetch: (accessToken) => {
        //window.console.log( "******************\n\nTokenRefreshLink ...",accessToken,'\n\n*******************' );
        setAccessToken(accessToken);
      },
      handleError: (err) => {
        window.console.warn('Your refresh token is invalid. Try to relogin: ', err, refres);
        window.console.error(err);
        relogin(auth);
      },
    }),
    onError(({ graphQLErrors, networkError }) => {
      // window.console.log(networkError);
      graphQLErrors;
      // window.console.log(graphQLErrors[0].message);
      if (!networkError) {
        // por si se limpia la cache del navegador
        //window.location.href = process.env.VUE_APP_DOMAIN+'/'+process.env.VUE_APP_BASE_URL;
        // window.console.log( 'redirir a portal???' )

        //const datauser = window.localStorage.getItem( "USERDATALOGIN" );
        const ocultito = window.localStorage.getItem('USERDATALOGIN');
        let decryptedBytes = window.CryptoJS.AES.decrypt(ocultito, 'estanoesunaclavesecreta');
        let plaintext = decryptedBytes.toString(window.CryptoJS.enc.Utf8);
        //  window.console.log( 'DECRYPTO:',plaintext );
        const datauser = plaintext;
        var u = JSON.parse(datauser);
        if (!u) return;
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        var raw = JSON.stringify({ username: u.user, password: u.clave });
        var requestOptions = { method: 'POST', headers: myHeaders, body: raw };

        fetch(process.env.VUE_APP_AUTH_POST, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            /*window.console.log( result ) */ result;
          })
          .catch((error) => window.console.log('error', error));
      } else {
        relogin(auth);
      }
    }),
    requestLink,
    new HttpLink({
      uri: gra,
      credentials: 'include',
    }),
  ]),
  cache,
  defaultOptions: defaultOptions,
});

// 
// 

const client_proys = createHttpLink({ uri: proyectos, credentials: 'same-origin' });

const httpLinkProys = new ApolloClient({
  connectToDevTools: process.browser,
  ssrMode: !process.browser,
  link: client_proys,
  cache: cache,
  defaultOptions: defaultOptions,
});

const client = createHttpLink({ uri: auth, credentials: 'include' });

const httpLinkAuth = new ApolloClient({
  connectToDevTools: process.browser,
  ssrMode: !process.browser,
  link: client,
  cache,
});

export const apolloProvider = new VueApollo({
  clients: {
    apolloClient,
    httpLinkAuth,
    cliente_proys: httpLinkProys,
  },
  defaultClient: apolloClient, 
});
Vue.config.productionTip = true;

new Vue({
  vuetify,
  apolloProvider,
  router,
  store,
  render: (h) => h(App),
  watch: {
    '$store.state.CARGO': function() {
      this.$store.dispatch('obtenerTokenFactura');
    },
    '$store.state.DATA_USER': function(a) {
      conectarws(a,this.$store)
    },
  },
}).$mount('#app');
